import React, { useEffect, useState } from "react";
import { InfoTip } from "@/components/InfoTip";
import { FileText, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useTranslation } from "react-i18next";

// Settings → Mes factures: receipts / invoices emailed after each pack purchase.
export function MyInvoices() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    api.get("/billing/invoices").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  const download = async (inv) => {
    setBusy(inv.id);
    try {
      const { data } = await api.get(`/billing/invoices/${inv.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `SUX1_${inv.number}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
    } catch {
      toast.error(t("invoices.error"));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="mt-6 max-w-3xl border border-border p-6" data-testid="settings-invoices">
      <div className="sux-marker mb-3 flex items-center gap-2"><FileText className="w-3 h-3" /> {t("invoices.title")} <InfoTip testid="settings-invoices-info" content={t("tips.invoices", "Un justificatif PDF par achat, aussi envoyé par e-mail. Téléchargez-le ici pour votre comptabilité ou un remboursement par votre employeur.")} /></div>
      {items === null ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : items.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="settings-invoices-empty">
          {t("invoices.empty")}
        </p>
      ) : (
        <ul className="divide-y divide-border border-t border-border" data-testid="settings-invoices-list">
          {items.map((inv) => (
            <li key={inv.id} className="py-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`settings-invoice-${inv.number}`}>
              <span className="font-mono flex-1 min-w-[160px]">
                {inv.kind === "invoice" ? t("invoices.invoice") : t("invoices.receipt")} n° {inv.number}
              </span>
              <span className="text-muted-foreground">{new Date(inv.created_at).toLocaleDateString(i18n.language === "en" ? "en-GB" : "fr-FR")}</span>
              <span>{inv.credits} {t("invoices.credits")} · {inv.amount_eur.toFixed(2).replace(".", ",")} €</span>
              <button
                type="button"
                onClick={() => download(inv)}
                disabled={busy === inv.id}
                data-testid={`settings-invoice-download-${inv.number}`}
                className="inline-flex items-center gap-1.5 font-mono uppercase tracking-[0.14em] text-[10px] px-3 py-1.5 border border-border hover:bg-[#002FA7] hover:text-white hover:border-[#002FA7] transition-colors disabled:opacity-50"
              >
                {busy === inv.id ? <Loader2 className="w-3 h-3 animate-spin" /> : <Download className="w-3 h-3" />} PDF
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default MyInvoices;
